// If considering jQuery, Make sure to use document ready or window.onload for StorybookJS to hook into events
(function ($) {

    Drupal.behaviors.scrollane = {
        attach: function (context) {
            let sliders = document.getElementsByClassName('js-scroll-lane'),
                windowWidth = window.innerWidth;

            scrollLaneBehaviour(sliders, windowWidth);

            window.addEventListener('resize', function () {
                if (this.resizeTO) clearTimeout(this.resizeTO);

                this.resizeTO = setTimeout(function () {
                    let resizeSliders = document.getElementsByClassName('js-scroll-lane'),
                        resizeWindowWidth = window.innerWidth;

                    scrollLaneBehaviour(resizeSliders, resizeWindowWidth);
                }, 500);
            });

            function scrollLaneBehaviour(sliders, windowWidth) {
                for (let sliderThis of sliders) {
                    let sliderFullWidth;

                    sliderFullWidth = sliderThis.scrollWidth;

                    if (sliderFullWidth > windowWidth) {
                        sliderThis.classList.add('has-scrollbar');
                        dragSlider(sliders);
                    } else if (sliderFullWidth <= windowWidth) {
                        if (sliderThis.classList.value.includes('has-scrollbar')) {
                            sliderThis.classList.remove('has-scrollbar');
                        }
                    }
                }
            }


            function dragSlider(sliders) {
                if (!matchMedia('(hover: none)').matches) {
                    for (let slider of sliders) {
                        mouseHandler(slider);
                    }
                }
            }

            function mouseHandler(ele) {
                let pos = {left: 0, x: 0};

                    function mouseDownHandler(e) {
                        ele.style.cursor = 'grabbing';
                        ele.style.userSelect = 'none';

                        pos = {
                            // The current scroll
                            left: ele.scrollLeft,
                            // Get the current mouse position
                            x: e.clientX,
                        };

                        document.addEventListener('mousemove', mouseMoveHandler);
                        document.addEventListener('mouseup', mouseUpHandler);

                    }

                    function mouseMoveHandler(e) {
                        // How far the mouse has been moved

                        let dx = e.clientX - pos.x;

                        // Scroll the element0
                        ele.scrollLeft = pos.left - dx;
                    }

                    function mouseUpHandler() {
                        ele.style.cursor = 'grab';
                        ele.style.removeProperty('user-select');

                        document.removeEventListener('mousemove', mouseMoveHandler);
                        document.removeEventListener('mouseup', mouseUpHandler);
                    }

                ele.style.cursor = 'grab';

                ele.addEventListener('mousedown', mouseDownHandler);
            }

            function hasScrollBar($this) {
                return $this.scrollWidth > $this.clientWidth;
            }
        }
            /*
            let elm = document.querySelector('.js-scroll-lane .scroll-lane__outer', context);

            if (!elm) {
                return false;
            }

            let pos = {
                left: 0,
                x: 0
            }

            let mouseDownHandler = function (e) {
                elm.style.cursor = 'grabbing';
                elm.style.userSelmct = 'none';

                pos = {
                    // The current scroll
                    left: elm.scrollLeft,
                    // Get the current mouse position
                    x: e.clientX,
                };

                document.addEventListener('mousemove', mouseMoveHandler);
                document.addEventListener('mouseup', mouseUpHandler);

            }

            let mouseMoveHandler = function (e) {
                // How far the mouse has been moved
                var dx = e.clientX - pos.x;

                // Scroll the elmment0
                elm.scrollLeft = pos.left - dx;
            }

            let mouseUpHandler = function () {
                elm.style.cursor = 'grab';
                elm.style.removeProperty('user-selmct');

                document.removeEventListener('mousemove', mouseMoveHandler);
                document.removeEventListener('mouseup', mouseUpHandler);
            };

            elm.style.cursor = 'grab';
            elm.addEventListener('mousedown', mouseDownHandler);
             */
    }
}(jQuery));